import { useContext } from 'react';
import { TrackingContext } from "./TrackingContext";
export var useTrackingContext = function useTrackingContext() {
  var context = useContext(TrackingContext);
  if (context === undefined) {
    throw new Error('useTrackingContext must be used withing an TrackingProvider');
  }
  return context;
};
export default useTrackingContext;